import { computed, Injectable, Signal, signal, WritableSignal } from '@angular/core';

// A page must claim in its field initializers or constructor — components are instantiated before
// NavigationEnd, so claiming any later would let the overlay release first and bring back the two-loader seam.
@Injectable({
  providedIn: 'root',
})
export class BootLoaderService {
  #pendingClaims: WritableSignal<number> = signal(0);

  isContentPending: Signal<boolean> = computed(() => this.#pendingClaims() > 0);

  // Returns an idempotent release function — safe to call from several places (e.g. both on content-ready and on destroy).
  claim(): () => void {
    this.#pendingClaims.update((count: number) => count + 1);

    let released = false;

    return () => {
      if (released) {
        return;
      }

      released = true;
      this.#pendingClaims.update((count: number) => Math.max(0, count - 1));
    };
  }

  /** Escape hatch for the app-level safety cap: a stuck claim must never strand the overlay. */
  releaseAll(): void {
    this.#pendingClaims.set(0);
  }
}
